import { utilities } from '@weatherbug/common';

const { units } = utilities;
const { speedUnits, pressureUnits } = units;

// matching what user filter attribute uses for user units
const oldUnitTypes = {
    mph: 'm/h',
    kph: 'km/h',
    mps: 'm/s',
    knots: 'knots'
} as const;

export const oldPressureUnitTypes = {
    inches: 'Inches',
    millibars: 'mb'
} as const;

/**
 * getWindUnitType will support old units that the 
 * Web backend uses and matches what common js uses
 * units in wb/common should be the standard
 */
export const getWindUnitType = (value: string): number => {
    switch (value?.toLowerCase())
    {
        case oldUnitTypes.mph:
            return speedUnits.mph;
        case oldUnitTypes.kph:
            return speedUnits.kph;
        case oldUnitTypes.knots:
            return speedUnits.knots;
        case oldUnitTypes.mps:
            return speedUnits.mps;
        default: 
            return speedUnits.mph;
    }
};

/**
 * getPressureUnitType will support old units that the 
 * Web backend uses and matches what common js uses
 * units in wb/common should be the standard
 * Web backend logic: PressureUnitType = pressureUnitVal == 1 ? "Inches" : "mb"; :/
 */
export const getPressureUnitType = (value: string): number => {
    switch (value?.toLowerCase())
    {
        case oldPressureUnitTypes.inches.toLowerCase():
            return pressureUnits.inches;
        case oldPressureUnitTypes.millibars:
            return pressureUnits.millibars;
        default: 
            return pressureUnits.inches;
    }
};

export const WindDirectionUnitEnum = {
    1: 'NNE',
    2: 'NE',
    3: 'ENE',
    4: 'E',
    5: 'ESE',
    6: 'SE',
    7: 'SSE',
    8: 'S',
    9: 'SSW',
    10: 'SW',
    11: 'WSW',
    12: 'W',
    13: 'WNW',
    14: 'NW',
    15: 'NNW',
    16: 'N'
} as const;

export const getWindDirection = (windDirectionDegrees: number) => {
    if (typeof windDirectionDegrees !== 'number') {
        return null;
    }

    windDirectionDegrees /= 22.5;

    switch (Math.round(windDirectionDegrees)) {
        case 0:
        case 16:
        default:
            return WindDirectionUnitEnum[16];
        case 1:
            return WindDirectionUnitEnum[1];
        case 2:
            return WindDirectionUnitEnum[2];
        case 3:
            return WindDirectionUnitEnum[3];
        case 4:
            return WindDirectionUnitEnum[4];
        case 5:
            return WindDirectionUnitEnum[5];
        case 6:
            return WindDirectionUnitEnum[6];
        case 7:
            return WindDirectionUnitEnum[7];
        case 8:
            return WindDirectionUnitEnum[8];
        case 9:
            return WindDirectionUnitEnum[9];
        case 10:
            return WindDirectionUnitEnum[10];
        case 11:
            return WindDirectionUnitEnum[11];
        case 12:
            return WindDirectionUnitEnum[12];
        case 13:
            return WindDirectionUnitEnum[13];
        case 14:
            return WindDirectionUnitEnum[14];
        case 15:
            return WindDirectionUnitEnum[15];
    }
};
